import React, {
	ChangeEventHandler,
	MouseEventHandler,
	ReactElement,
	ReactNode,
	forwardRef,
} from 'react';
import styled from 'styled-components';

import { ColorTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

import StyledRadio from './StyledRadio.component';

export interface IRadioButtonProps {
	name?: string;
	value?: string;
	label?: string | ReactElement;
	checkedColor?: ColorTypes;
	children?: ReactNode;
	className?: string;
	disabled?: boolean;
	stacked?: boolean;
	onClick?: MouseEventHandler;
	onLabelClick?: MouseEventHandler;
	onChange?: ChangeEventHandler;
	checked?: boolean;
	variant?: 'default' | 'small';
}

type Ref = HTMLInputElement;

const RadioLabel = styled.label<{ disabled: boolean }>`
	position: relative;
	display: flex;
	cursor: pointer;
	line-height: ${theme.lineHeights.body.md};
	font-size: ${theme.fontSizes.body.md};
`;

const RadioButton = forwardRef<Ref, IRadioButtonProps>(
	(
		{
			name,
			value,
			label,
			onChange,
			children,
			className,
			onClick,
			onLabelClick,
			checkedColor = 'cyan',
			disabled = false,
			stacked = false,
			checked,
			variant = 'default',
		},
		ref
	) => {
		return (
			<RadioLabel className={className} onClick={onLabelClick} disabled={disabled}>
				<StyledRadio
					name={name}
					value={value}
					onClick={onClick}
					ref={ref}
					checkedColor={checkedColor}
					disabled={disabled}
					stacked={stacked}
					onChange={onChange}
					checked={checked}
					variant={variant}
				/>
				<span>{label ?? children}</span>
			</RadioLabel>
		);
	}
);

export default styled(RadioButton)``;
RadioButton.displayName = 'RadioButton';
